<template>
  <div>
    <a href="javascript:"
       :class="{active: activePage === 'candidateNotes' }"
       @click="$emit('setCandidatePage', 'candidateNotes')"
    >
      <i class="fal fa-pencil"></i> Notities
    </a>
    <a href="javascript:"
       :class="{active: activePage === 'candidateInformation' }"
       @click="$emit('setCandidatePage', 'candidateInformation')"
    >
      <i class="fal fa-user"></i> Persoonlijke gegevens
    </a>

    <a v-if="isAdmin"
       href="javascript:"
       :class="{active: activePage === 'candidatePlace' }"
       @click="$emit('setCandidatePage', 'candidatePlace')"
    >
      <i class="fal fa-user-hard-hat"></i> Kandidaat plaatsen
    </a>
    <a href="javascript:"
       :class="{active: activePage === 'candidatePlacings' }"
       @click="$emit('setCandidatePage', 'candidatePlacings')"
    >
      <i class="fal fa-user-check"></i> Plaatsingen
    </a>
    <a href="javascript:"
       :class="{active: activePage === 'candidateAppointments' }"
       @click="$emit('setCandidatePage', 'candidateAppointments')"
    >
      <i class="fal fa-history"></i> Afspraken historie
    </a>
    <a href="javascript:"
       :class="{active: activePage === 'candidateAppointment' }"
       @click="$emit('setCandidatePage', 'candidateAppointment')"
    >
      <i class="fal fa-calendar-plus"></i> Afspraak inplannen
    </a>
    <a href="javascript:"
       :class="{active: activePage === 'candidateDocuments' }"
       @click="$emit('setCandidatePage', 'candidateDocuments')"
    >
      <i class="fal fa-file"></i> Bestanden
    </a>
    <a href="javascript:"
       :class="{active: activePage === 'candidatePoolOverview' }"
       @click="$emit('setCandidatePage', 'candidatePoolOverview')"
    >
      <i class="fal fa-user-clock"></i> Poules
    </a>
    <a href="javascript:"
       :class="{active: activePage === 'candidateSickness' }"
       @click="$emit('setCandidatePage', 'candidateSickness')"
    >
      <i class="fal fa-user-injured"></i> Ziek meldingen
    </a>
    <a href="javascript:"

       @click="createContract()"
    >
      <i class="fal fa-file"></i> Contract aanmaken
    </a>
    <div v-if="candidate" class="fase34-checkbox" :class="{'active': candidate.fase34}">
      <i class="fal fa-flag"></i> Fase 3/4
      <div class="custom-control custom-checkbox">
        <input
            type="checkbox"
            id="fase34"
            class="custom-control-input"
            :checked="candidate.fase34"
            @change="$emit('fase34Changed')"
        />
        <label class="custom-control-label" for="fase34"></label>
      </div>
    </div>
    <a v-if="hasAppAccount"
       href="javascript:"
       @click="openChat()"
    >
      <i class="fal fa-comment"></i> Chat
    </a>
  </div>
</template>
<script>
import store from '@/store';

export default {
  props: {
    activePage: String,
    candidate: Object,
    hasAppAccount: Boolean
  },
  data() {
    return {
      candidatePage: 'candidateNotes',
    }
  },
  computed: {
    isAdmin() {
      return store.state.users.me.admin;
    }
  },
  methods: {
    createContract() {

      this.$router.push({path: '/contracts/add' + '?candidateId=' + this.$route.params.id})
    },
    openChat() {
      this.$router.push({name: 'chat', query: {candidate: this.$route.params.id}})
    }
  }
}
</script>

<style lang="scss" scoped>
.fase34-checkbox {
  position: relative;
  display: block;
  font-size: 14px;
  padding: 0.5rem 0;
  line-height: 34px;
  color: #8d97ad;

  &.active {
    color: #25b7bc;
  }

  i {
    width: 24px;
    text-align: center;
    display: inline-block;
  }

  .custom-control {
    position: absolute;
    right: 0;
    top: 15%;
    transform: translateY(-50%);
  }
}
</style>